import React from "react";
import { ReactSession } from "react-client-session";
import { __EmptyValue } from "./Utils";

export function getSession(name) {
    return __EmptyValue(ReactSession.get(name)) ? false : ReactSession.get(name);
}

export function setSession(name, value) {
    ReactSession.set(name, value);
}

export function closeSession(name) {
    ReactSession.remove(name);
}
